import React from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { CalendarClock, AlertTriangle, CheckCircle } from 'lucide-react';
import { formatFecha, formatRelativo } from '../../utils/dateFormat';

const TIPO_LABEL = {
  fin_contrato: 'Fin de contrato',
  licitacion_gestion: 'Licitación',
  revision: 'Revisión',
  custom: 'Aviso',
};

const AvisoCard = ({ a, onDone }) => {
  const hoy = new Date();
  const fAviso = a.fecha_aviso ? new Date(a.fecha_aviso) : null;
  const fEvento = a.fecha_evento ? new Date(a.fecha_evento) : null;
  const diasRestantes = fEvento ? Math.ceil((fEvento - hoy) / 86400000) : null;
  const urgente = diasRestantes !== null && diasRestantes <= 15;
  const retraso = fAviso && fAviso <= hoy;
  const tone = retraso || urgente ? 'bg-amber-50 border-amber-300' : 'bg-white border-ink-200';

  return (
    <Card className={`p-4 card-hover ${tone}`} data-testid={`aviso-${a.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            {urgente
              ? <AlertTriangle className="w-4 h-4 text-amber-600 shrink-0" />
              : <CalendarClock className="w-4 h-4 text-brand-600 shrink-0" />}
            <Badge variant="outline" className="text-[10px] bg-white border-ink-200 text-ink-600">
              {TIPO_LABEL[a.tipo] || a.tipo}
            </Badge>
            {diasRestantes !== null && (
              <span className={`text-[11px] font-medium ${urgente ? 'text-amber-700' : 'text-ink-500'}`}>
                {formatRelativo(a.fecha_evento)}
              </span>
            )}
          </div>
          <p className="font-semibold text-ink-900 text-sm truncate">{a.titulo}</p>
          <p className="text-xs text-ink-500 mt-0.5 truncate">
            {a.gestora_nombre && <>{a.gestora_nombre} · </>}{a.contrato_nombre}
          </p>
          <p className="text-[11px] text-ink-400 mt-1">
            Evento: {formatFecha(a.fecha_evento)} · Avisar: {formatRelativo(a.fecha_aviso)}
          </p>
        </div>
        <button
          onClick={onDone}
          className="p-1.5 rounded hover:bg-emerald-50 text-emerald-600 shrink-0"
          title="Marcar como completado"
          data-testid={`btn-completar-aviso-${a.id}`}
        >
          <CheckCircle className="w-4 h-4" />
        </button>
      </div>
    </Card>
  );
};

export default AvisoCard;
